/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Propagation_HintInputs */



/**
* | output |
* | --- |
* | "DNS changes can take a few minutes to a few hours to become visible." |
*
* @param {Canvas_Domain_Propagation_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_propagation_hint = /** @type {((inputs?: Canvas_Domain_Propagation_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Propagation_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("DNS-Änderungen können einige Minuten bis mehrere Stunden brauchen, bis sie sichtbar sind.")
	return /** @type {LocalizedString} */ ("DNS changes can take a few minutes to a few hours to become visible.")
});